import React from 'react';

interface Props {
  title: string;
  description?: string;
}

const SaleCancelSectionHeader: React.FC<Props> = ({ title, description }) => {
  return (
    <div className="mb-4">
      <h3 className="text-lg font-semibold text-black dark:text-white">{title}</h3>
      {description && (
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">{description}</p>
      )}
    </div>
  );
};

export default SaleCancelSectionHeader;
